import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModelUpdatedEvent } from '@ag-grid-community/core';
import { AgGridReact } from '@ag-grid-community/react';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { Grid, Typography } from '@mui/material';
import React, { FC } from 'react';

import { muiStyles } from './styles';
import { SimpleTableProps } from './types';
import { useAgGrid } from '../hooks/useAgGrid';

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-063642}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Tassat_Group_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{24_September_2025}____[v3]_[01]_MTc1ODY2ODQwMDAwMA==99c518002bb6b169f838210945d092e7');

export const SimpleTable: FC<SimpleTableProps> = (props) => {
    const {
        title,
        Subtitle,
        AboveHeaderComponent,
        ...gridProps
    } = props;

    const classes = muiStyles(props);

    const [ gridApi, onGridReady ] = useAgGrid();

    const onModelUpdated = React.useCallback((_: ModelUpdatedEvent) => gridApi?.api.sizeColumnsToFit(), [gridApi]);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
        >
            <Grid
                alignItems='center'
                className={classes.titleContainer}
                container
                justifyContent='space-between'
            >
                <Typography
                    className={classes.title}
                    data-testid='simpleTable-title'
                    variant='body1'
                >
                    {title}
                </Typography>
                {typeof Subtitle === 'string' ? (
                    <Typography
                        className={classes.title}
                        data-testid='simpleTable-subtitle'
                        variant='body1'
                    >
                        {Subtitle}
                    </Typography>
                ) : Subtitle ? (
                    <Subtitle />
                ) : null}
            </Grid>
            {AboveHeaderComponent ? <AboveHeaderComponent /> : null}
            <Grid
                className={classes.gridContainer}
                container
            >
                <div
                    className='ag-theme-material'
                    style={{
                        height: '100%',
                        width: '100%'
                    }}
                >
                    <AgGridReact
                        {...gridProps}
                        animateRows={false}
                        columnDefs={gridProps.columnDefs}
                        columnMenu='legacy'
                        defaultColDef={gridProps.defaultColDef || {
                            resizable: true,
                            filter: true,
                            sortable: true
                        }}
                        enableCellTextSelection={gridProps.enableCellTextSelection || true}
                        gridOptions={{ headerHeight: gridProps.gridOptions?.headerHeight || 26 }}
                        headerHeight={gridProps.headerHeight || 26}
                        modules={[ClientSideRowModelModule]}
                        onGridReady={onGridReady}
                        onModelUpdated={gridProps.onModelUpdated || onModelUpdated}
                        rowData={gridProps.rowData}
                        rowHeight={gridProps.rowHeight || 26}
                        suppressCellFocus={gridProps.suppressCellFocus || true}
                        suppressContextMenu={gridProps.suppressContextMenu || true}
                    />
                </div>
            </Grid>
        </Grid>
    );
};